import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import FinalLNPSampleContext from "../../../context/materialcapture/FinalLNPSampleContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import FinalLNPSampleForm from "../../../components/materialscapture/FinalLNPSampleForm";

const FinalLNPSampleCreatePage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { apiRes, setApiRes } = useContext(FinalLNPSampleContext);

  const backURL = '/materials-capture';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Final LNP Sample']);
  }, [permisionsList]);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Final LNP Sample'} backURL={backURL} />
        <FinalLNPSampleForm />

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default FinalLNPSampleCreatePage;